export class ObjectType {
    Id: number;
    ObjectType: string;
    Status: string;
    ApplicationId: number;
    BusinessId: number;
}
